import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getUserBillingHistory() {
    return this.http.get<any>(`${environment.apiUrl}/billing_history/user`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  getAdminBillingHistory(pageNumber: number = 1, search_name: string, fromDateYmd: string, toDateYmd: string) {
    return this.http.post<any>(`${environment.apiUrl}/admin/billing_history/admin`, {
      page: pageNumber,
      search_name: search_name,
      date_from: fromDateYmd,
      date_to: toDateYmd
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

}
